export enum DataFieldType {
  TEXT,
  NUMBER,
  BOOLEAN,
  DATE,
  SELECT,
}

export interface TextDataField {
  type: DataFieldType.TEXT;
  key: string;
  label: string;
  format?: "code";
}

export interface NumberDataField {
  type: DataFieldType.NUMBER;
  key: string;
  label: string;
  float?: boolean;
}

export interface BooleanDataField {
  type: DataFieldType.BOOLEAN;
  key: string;
  label: string;
}

export interface DateDataField {
  type: DataFieldType.DATE;
  key: string;
  label: string;
}

export interface SelectDataField {
  type: DataFieldType.SELECT;
  key: string;
  label: string;
  options: Record<string, string>;
}

export interface SelectOption {
  key: string;
  value: string;
  label: string;
}

export type DataField =
  | TextDataField
  | NumberDataField
  | BooleanDataField
  | DateDataField
  | SelectDataField;
